import { Instagram } from "lucide-react";
import { useSettings } from "@/lib/site";
import { Eyebrow, OutLink, Reveal, Tbc } from "@/components/site/Bits";

export function InstagramLink({ dark = true, testid = "instagram-link" }) {
    const s = useSettings();
    if (!s.instagram_url) return <Tbc className={dark ? "border-sage/60 text-sage" : ""}>Instagram handle — TBC</Tbc>;
    return (
        <OutLink href={s.instagram_url} event="instagram_click" label={testid} testid={testid}
                 className={`rounded-full px-6 py-3.5 text-sm font-medium transition-colors ${dark ? "bg-cream text-forest hover:bg-sage" : "bg-forest text-cream hover:bg-forest-hover"}`}>
            <Instagram className="h-4 w-4" /> Follow {s.instagram_handle || "Pieter"} on Instagram
        </OutLink>
    );
}

export default function WalkTheLand({ heading = true, image = "/walk-the-land-cascais.jpg", imageAlt = "Pieter walking a 30,000 m² plot north of Cascais, from his Instagram" }) {
    const s = useSettings();
    return (
        <section id="walk-the-land" data-testid="walk-the-land" className="bg-forest text-cream py-24 md:py-36 overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
                <Reveal className="lg:col-span-5 relative">
                    <div className="relative overflow-hidden rounded-[2rem] aspect-[3/4]">
                        <img src={image} alt={imageAlt} loading="lazy" className="h-full w-full object-cover" />
                    </div>
                </Reveal>
                <div className="lg:col-span-7">
                    {heading && <Reveal><Eyebrow dark>Walk the Land</Eyebrow></Reveal>}
                    <Reveal delay={100}>
                        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-tight mt-8">
                            Every project <em className="italic text-sage">we walk.</em>
                        </h2>
                    </Reveal>
                    <Reveal delay={200} className="mt-10 space-y-5 text-base md:text-lg text-cream/80 leading-relaxed max-w-xl">
                        <p>Before we set foot on a property, our technology has already done the groundwork — analysing location, planning regulations, development potential and connecting us with sellers.</p>
                        <p>Then we walk the land. We study the terrain, the boundaries, the surroundings. How the light falls. What's next door. What others might overlook. And most importantly, what the land could become. Because some things can't be understood from behind a screen.</p>
                        <p>Data tells us where to look. Walking the land tells us whether to invest. Every plot. No exceptions.</p>
                    </Reveal>
                    <Reveal delay={300} className="mt-10"><InstagramLink /></Reveal>
                </div>
            </div>
        </section>
    );
}
